import React from 'react';
import { Modal, Button, CircularLoader } from 'utils';
import {getFormattedDateTime} from '../Utilities';
import styles from './gift-card.module.scss';

function ConfirmModal({
    isFetchingGc,
    gcError,
    gcOrderDetail,
    gcSuccessMsg,
    formValues,
    card,
    onConfirm,
    onClose
}) {
    const denomination = parseInt(formValues.denomination);
    const quantity = parseInt(formValues.quantity);
    const discount = card.offer ? parseFloat(card.offer) : 0;

    function renderContent() {
        if (isFetchingGc) {
            return (
                <div className={styles.loader}>
                    <CircularLoader />
                </div>
            );
        } else if (gcSuccessMsg && gcOrderDetail) {
            
            var giftcards = [];
            for (let i = 0; i < gcOrderDetail.cards.length; i++) {
            giftcards.push(
                <div  className={styles.item}>
                    <p><span>{gcOrderDetail.cards[i].cardNumber}</span><img className="copy_icon" src={'copy-svgrepo-com.svg'}
                                        onClick={()=>{
                                            var textField = document.createElement('textarea');
                                            textField.innerText = gcOrderDetail.cards[i].cardNumber;
                                            document.body.appendChild(textField);
                                            textField.select();
                                            document.execCommand('copy');
                                            textField.remove();
                                        }}
                                    /></p>
                    <p><span className="blur_text">{gcOrderDetail.cards[i].cardPin}</span><img className="copy_icon" src={'copy-svgrepo-com.svg'}
                                        onClick={()=>{
                                            var textField = document.createElement('textarea');
                                            textField.innerText = gcOrderDetail.cards[i].cardPin;
                                            document.body.appendChild(textField);
                                            textField.select();
                                            document.execCommand('copy');
                                            textField.remove();
                                        }}
                                    /></p>
                </div>
            )
        }

            return (
                <>
                    <div className={styles.carddeatils}>
                    <div className={styles.heading}>
                    <p className={styles.productName}>{gcOrderDetail.productName}</p>
                    <p className={styles.productAmount}>worth ₹ {parseFloat(gcOrderDetail.amount).toFixed(2)}</p>
                    <p className={styles.productValidity}>Validity: {getFormattedDateTime(gcOrderDetail.cards[0].validity)}</p>
                    </div>
                    <div className={styles.cards}>
                    <div  className={styles.item}>
                    <p>Card Number</p>
                    <p>Card Pin</p>
                    </div>
                            {giftcards}
                    </div>
                    <p className={styles.btn_box}>
                    <Button
                        label="Go Back"
                        className={styles.button}
                        width={200}
                        onClick={onClose}
                    />
                    </p>
                </div>
                </>
            );
        } else if (gcError) {
            return (
                <>
                    <p className={styles.heading}>Oops!</p>
                    <p className={styles.text}>{gcError}</p>
                    <Button
                        label="Go Back"
                        className={styles.button}
                        onClick={onClose}
                    />
                </>
            );
        }

        return (
            <>
                <p className={styles.heading}>Please Confirm</p>
                <p className={styles.text}>
                    Are you sure you want to purchase{' '}
                    <strong>
                        {quantity} x {parseFloat(denomination).toFixed(2)} Rs
                    </strong>{' '}
                    gift cards with total value of{' '}
                    <strong>
                        {parseFloat(
                            denomination * quantity -
                                (denomination * quantity * discount) / 100
                        ).toFixed(2)}{' '}
                        Rs
                    </strong>{' '}
                    {discount > 0 && (
                        <span>
                            (after <strong>{discount}%</strong> discount)
                        </span>
                    )}
                    ?
                </p>
                <Button
                    label="Confirm"
                    className={styles.button}
                    width={200}
                    onClick={onConfirm}
                />
            </>
        );
    }

    return (
        <Modal
            classname={styles.modal}
            onClose={!isFetchingGc ? onClose : null}
        >
            {renderContent()}
        </Modal>
    );
}

export default ConfirmModal;
